import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=165eb88c&scoped=true"
import script from "./Sites.vue?vue&type=script&lang=js"
export * from "./Sites.vue?vue&type=script&lang=js"
import style0 from "./Sites.vue?vue&type=style&index=0&id=165eb88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165eb88c",
  null
  
)

export default component.exports